<div class="info-container" [class]="important ? 'important' : 'regular'" matTooltip="Clique para fechar" *ngIf="isOpen" (click)="close()">
  <span>{{ description }}</span>
</div>
